import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { DateTime } from 'luxon';
import { ResponseAnprData } from 'shell/models/person';
import { BodyChangeRelationship } from 'mutation/view-models/registration-citizenship';

export const transformFamilyMembers = (
  httpResponse: AxiosResponse<HttpResponse<ResponseAnprData>>
): Array<BodyChangeRelationship> => {
  const data = httpResponse.data.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || [];

  const familyRes: Array<BodyChangeRelationship> = data.map((item) => {
    let birthplace = '';
    // birthplace check for object
    if (item.generalita?.luogoNascita?.localita) {
      birthplace = `${item.generalita?.luogoNascita?.localita.descrizioneLocalita} (${item.generalita?.luogoNascita?.localita.descrizioneStato})`;
    }

    if (item.generalita?.luogoNascita?.comune) {
      birthplace = `${item.generalita?.luogoNascita?.comune.nomeComune} (${item.generalita?.luogoNascita?.comune.siglaProvinciaIstat})`;
    }

    // Residence check for object
    let residence = '';
    // scelgo il primo o è un array?
    if ((item.residenza || [])[0]?.indirizzo) {
      residence = `${(item.residenza || [])[0]?.indirizzo?.comune?.nomeComune || ''} (${
        (item.residenza || [])[0]?.indirizzo?.comune?.siglaProvinciaIstat || ''
      })`;
    }
    // scelgo il primo o è un array?
    if ((item.residenza || [])[0]?.localitaEstera) {
      residence = `${(item.residenza || [])[0]?.localitaEstera?.indirizzoEstero?.localita} (${
        (item.residenza || [])[0]?.localitaEstera?.consolato?.descrizioneConsolato
      })`;
    }

    let state = '';
    // state check for object
    if (item.generalita?.soggettoAIRE && item.generalita?.soggettoAIRE === 'S') {
      state = 'Iscritto AIRE';
    }

    if (item.datiCancellazione) {
      state = `${item.datiCancellazione.motivoCancellazione}`;
    }

    if ((item.residenza || [])[0]?.indirizzo?.toponimo) {
      const toponym = (item.residenza || [])[0]?.indirizzo?.toponimo;

      const civic = (item.residenza || [])[0]?.indirizzo?.numeroCivico;

      state = `${toponym?.specie} ${toponym?.denominazioneToponimo},${civic?.numero}${
        civic?.esponente1 ? `/${civic.esponente1}${civic.lettera}` : ''
      }`;
    }

    return {
      fiscalCode: item.generalita?.codiceFiscale?.codFiscale || '',
      surname: item.generalita?.cognome || '',
      name: item.generalita?.nome || '',
      gender: item.generalita?.sesso || '',
      dateBorn: item.generalita?.dataNascita
        ? DateTime.fromISO(item.generalita?.dataNascita).toFormat('dd/MM/yyyy')
        : '',
      placeBorn: birthplace || '',
      residence: residence || '',
      state: state || '',
      relationship: item.legameSoggetto?.codiceLegame || '',
      oldRelationship: item.legameSoggetto?.codiceLegame || '',
      idCard: item.generalita?.idSchedaSoggettoComune?.idSchedaSoggettoComuneIstat || '',
    };
  });

  return familyRes;
};
